import React from 'react';
import { TextField, Button, Paper, Stack, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const PurchaseFilter = ({
    fromDate,
    toDate,
    onFromDateChange,
    onToDateChange,
    onSubmit,
    loading,
    period,
    onPeriodChange
}) => {
    const { t } = useTranslation();
    const strings = t('purchaseAnalytics.filters', { returnObjects: true });
    const periodOptions = strings.periods;

    const periodValues = [
        'today',
        'yesterday',
        'last_7_days',
        'last_30_days',
        'last_90_days',
        'this_month',
        'last_month',
        'this_year',
        'custom'
    ];

    const handlePeriodChange = (e) => {
        if (onPeriodChange) onPeriodChange(e.target.value);
    };

    const isCustom = period === 'custom';

    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                mb: 3,
                borderRadius: 4,
                boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                border: '1px solid rgba(0,0,0,0.08)',
                bgcolor: '#FFFFFF'
            }}
        >
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }}>
                <FormControl size="small" sx={{ minWidth: 180 }}>
                    <InputLabel>{strings.period}</InputLabel>
                    <Select
                        value={period || 'last_30_days'}
                        label={strings.period}
                        onChange={handlePeriodChange}
                        sx={{
                            borderRadius: 2,
                            '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#75E6DA' },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#189AB4' }
                        }}
                    >
                        {periodValues.map((key) => (
                            <MenuItem key={key} value={key}>
                                {periodOptions[key]}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {isCustom && (
                    <>
                        <TextField
                            label={strings.fromDate}
                            type="date"
                            value={fromDate}
                            onChange={(e) => onFromDateChange(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                            sx={{
                                minWidth: 180,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: 2,
                                    '&:hover fieldset': { borderColor: '#75E6DA' },
                                    '&.Mui-focused fieldset': { borderColor: '#189AB4' }
                                }
                            }}
                        />
                        <TextField
                            label={strings.toDate}
                            type="date"
                            value={toDate}
                            onChange={(e) => onToDateChange(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                            size="small"
                            sx={{
                                minWidth: 180,
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: 2,
                                    '&:hover fieldset': { borderColor: '#75E6DA' },
                                    '&.Mui-focused fieldset': { borderColor: '#189AB4' }
                                }
                            }}
                        />
                    </>
                )}

                <Button
                    variant="contained"
                    onClick={onSubmit}
                    disabled={loading || (isCustom && (!fromDate || !toDate))}
                    startIcon={loading ? null : <FontAwesomeIcon icon={faSearch} />}
                    sx={{
                        minWidth: 120,
                        height: 40,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        bgcolor: '#189AB4',
                        boxShadow: 'none',
                        '&:hover': {
                            bgcolor: '#05445E',
                            boxShadow: '0 4px 12px rgba(5, 68, 94, 0.3)'
                        }
                    }}
                >
                    {loading ? t('common.buttons.loading') : strings.submit}
                </Button>
            </Stack>
        </Paper>
    );
};

export default PurchaseFilter;
